<template>
  <div class="bg-white w-full login">
    <AppLogo />
    <div class="p-2 flex flex-col h-full w-full">
      <form
        class="flex flex-col gap-4"
        @submit.prevent="signin()"
      >
        <div class="text-2xl border-b font-bold py-2">Willkommen bei expert</div>
        <div class="flex flex-col gap-3">
          <div class="text-lg py-2 font-bold">Anmelden</div>
          <div class="text-sm">Wenn Sie bei uns ein Benutzerkonto besitzen, melden Sie sich bitte an</div>
          <div>
            <input
              v-model="email"
              class="inp mail"
              type="text"
              :class="invalid ? 'invalid' : ''"
              required
              placeholder="E-Mail-Adresse*"
              @focus="invalid = false"
            />
          </div>
          <div>
            <input
              v-model="pass"
              class="inp pass"
              type="password"
              :class="invalid ? 'invalid' : ''"
              required
              placeholder="Passwort*"
              @focus="invalid = false"
            />
          </div>
        </div>
        <div class="grid grid-cols-2 gap-4 items-center justify-between">
          <div>
            <button
              type="submit"
              class="text-center btn-primary block w-full font-bold"
            >
              Anmelden
            </button>
          </div>
          <div class="text-right font-bold">
            <div
              class="text-sm py-4 text-primary"
              @click="$emit('navigateModal', 'PASSWORDRECOVER')"
            >
              Passwort vergessen?
            </div>
          </div>
        </div>
        <div
          class="text-error"
          :class="invalid ? '' : 'invisible'"
        >
          Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut
        </div>
      </form>
      <div class="flex mt-4 flex-col gap-4">
        <div class="text-lg py-2 font-bold">Neu bei expert?</div>
        <div class="text-sm border-b pb-2">Registriere dich jetzt, um exklusive Coupons einsehen zu können!</div>
        <a
          class="text-center btn-primary block w-full font-bold"
          @click="$emit('openRegister')"
          >Jetzt registrieren</a
        >
        <NuxtLink
          to="/app"
          class="block py-3 col-span-4 text-center text-xs"
          @click="$emit('navigateModal', 'NONE')"
        >
          Zurück
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getExpUserProfile } from '~/composables/ExpApi/expUser';
import { StateNames } from '#shared/statics.ts';
const { ensurePermissions } = usePushNotificationUtils();

onNuxtReady(async () => {
  ensurePermissions('TRACKING');
});

const email = ref('');
const pass = ref('');
const emit = defineEmits(['closeLogin', 'navigateModal', 'openRegister']);
const invalid = ref(false);
async function signin() {
  invalid.value = false;
  if (useCurrentUserState()?.value?.csrfToken == undefined) {
    await getExpUserProfile();
  }
  let data = null;
  try {
    data = await login(email.value, pass.value);
  } catch (error) {
    clearNuxtData(['userProfile', 'expUserProfile']);
    console.debug('Login Error:', error);
    invalid.value = true;
    email.value = '';
    pass.value = '';
  }

  if (data) {
    clearNuxtData('userProfile');
    await getExpUserProfile();
    await $fetch('/api/refreshToken', {
      method: 'GET',
      credentials: 'include',
    });

    useState(StateNames.NEO_SESSION).value = await $fetch('/api/user/getNeoSession');
    useState(StateNames.APP_USER_PROFILE).value = await $fetch('/api/user/getProfileData');
    useState(StateNames.APP_USER_SESSION).value = await $fetch('/api/user/getAppUserSession');

    emit('navigateModal', 'NONE');
  }
}
</script>
